/**
 * Created by Josef Jurca on 25.8.2017.
 */
import _ from 'lodash';


/**
 * Converts asset data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Payment data.
 */
export function convertFromPaymentGateways (data = {}) {

    let paymentGateways = _.get(data, ['result', 'objects']);

    return _.map(paymentGateways, (gateway) => {
        return {
            id: gateway.id || null,
            isDefault: gateway.isDefault || null,
            name: gateway.name || '',
            selectedBy: gateway.selectedBy || ''
        };
    });
}

/**
 * Converts data for configurePaymentGateways.
 *
 * @param {Object} gateway - Read data.
 * @param {string} userId - User ID.
 * @param {number} orderPrice - Order price.
 * @returns {Object} Data for read.
 */
export function convertForConfigurePaymentGateway (gateway, userId, orderPrice) {

    return {
        paymentGatewayId: gateway.id,
        intent: 'GetConfiguration',
        extraParameters: [
            {
                objectType: 'KalturaKeyValue',
                key: 'ORDER',
                value: orderPrice.order
            }, {
                objectType: 'KalturaKeyValue',
                key: 'PRICE',
                value: orderPrice.price
            }, {
                objectType: 'KalturaKeyValue',
                key: 'UserId',
                value: userId
            }
        ]
    };
}

/**
 * Converts configuration data from read.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Payment configuration data.
 */
export function convertFromConfigurePaymentGateway (data = {}) {

    let configurations = _.get(data, ['result', 'paymentGatewayConfiguration']),
        yaadRedirectUrl = '';

    _.forEach(configurations, (configuration) => {
        if (configuration.key === 'RedirectUrl') {
            yaadRedirectUrl = configuration.value;
        }
    });

    return yaadRedirectUrl;
}

/**
 * Converts data for convertForTransactionPurchase.
 *
 * @param {Object} purchaseParams - Read data.
 * @returns {Object} Data for read.
 */
export function convertForTransactionPurchase (purchaseParams) {

    return {
        purchase: {
            objectType: 'KalturaPurchase',
            productId: purchaseParams.productId,
            productType: purchaseParams.productType,
            currency: purchaseParams.currency,
            price: purchaseParams.price,
            paymentMethodId: purchaseParams.paymentMethodId,
            paymentGatewayId: purchaseParams.paymentGatewayId,
            adapterData: purchaseParams.adapterData
        }

    };
}

/**
 * Converts data from transactionPurchase.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Parsed data.
 */
export function convertFromTransactionPurchase (response) {

    let {result} = response;

    return {
        createdAt: result.createdAt || 0,
        id: result.id || '',
        paymentGatewayReferenceId: result.paymentGatewayReferenceId || '',
        paymentGatewayResponseId: result.paymentGatewayResponseId || '',
        transactionSuccess: result.state === 'OK' ? true : false
    };
}

/**
 * Converts data for convertForAddPaymentMethod .
 *
 * @param {Object} data - Read data.
 * @returns {Object} Data for read.
 */
export function convertForAddPaymentMethod (data) {
    return {
        paymentGatewayId: data.gatewayId,
        intent: 'AddPaymentMethod',
        extraParameters: [
            {
                objectType: 'KalturaKeyValue',
                key: 'UserId',
                value: data.userId
            }, {
                objectType: 'KalturaKeyValue',
                key: 'yaadRedirectUrl',
                value: data.redirectUrl
            }, {
                objectType: 'KalturaKeyValue',
                key: 'SubscriptionId',
                value: data.subscriptionId
            }
        ]
    };
}

/**
 * Converts data for convertForAddCard .
 *
 * @param {Object} data - Read data.
 * @returns {Object} Data for read.
 */
export function convertFromAddCard (data) {
    let configurations = _.get(data, ['result', 'paymentGatewayConfiguration']),
        yaadRedirectUrl = '';

    _.forEach(configurations, (configuration) => {
        if (configuration.key === 'RedirectUrl') {
            yaadRedirectUrl = configuration.value;
        }
    });

    return yaadRedirectUrl;
}

/**
 * Converts data for convertForAddCard .
 *
 * @param {Object} data - Read data.
 * @returns {Object} Data for read.
 */
export function convertForAddCard (data) {
    return {
        paymentGatewayId: data.defaultGateway,
        intent: 'addcard',
        extraParameters: [
            {
                objectType: 'KalturaKeyValue',
                key: 'UserId',
                value: data.userId
            },
            {
                objectType: 'KalturaKeyValue',
                key: 'subscriptionId',
                value: data.subscriptionId
            }
        ]
    };
}

/**
 * Converts data for productPriceList.
 *
 * @param {Object} subscriptionId - SubscriptionId.
 * @returns {Object} Data for read.
 */
export function convertForProductPrice (subscriptionId) {
    return {
        filter: {
            objectType: 'KalturaProductPriceFilter',
            subscriptionIdIn: subscriptionId,
            isLowest: false,
            couponCodeEqual: 'value'
        }

    };
}

/**
 * Converts product price data from read.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Product prices.
 */
export function convertFromProductPrice (data = {}) {

    let prices = _.get(data, ['result', 'objects']);

    return _.map(prices, (priceData) => {
        let {price} = priceData;

        return {
            price: {
                amount: price.amount || 0,
                currency: price.currency || '',
                currencySign: price.currencySign || ''
            },
            productId: priceData.productId || null,
            productType: priceData.productType || '',
            purchaseStatus: priceData.purchaseStatus || ''
        };
    });

}

/**
 * Converts data from read.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Payment method.
 */
export function convertFromAddPaymentMethod (data = {}) {

    let configurations = _.get(data, ['result', 'paymentGatewayConfiguration']),
        paymentConfiguration = {};

    _.forEach(configurations, function (configuration) {
        switch (configuration.key) {
            case 'AdapterId':
                paymentConfiguration.adapterId = configuration.value;
                break;
            case 'PartnerId':
                paymentConfiguration.partnerId = configuration.value;
                break;
            case 'paymentMethodId':
                paymentConfiguration.paymentMethodId = configuration.value;
                break;
            case 'reason':
                paymentConfiguration.reason = configuration.value;
                break;
        }
    });

    return paymentConfiguration;
}

/**
 * Converts data for cancelPayment.
 *
 * @param {Object} paymentParams - Payment params.
 * @returns {Object} Data for read.
 */
export function convertForCancelPayment (paymentParams) {

    let {subscriptionId, paymentGatewayId, userId} = paymentParams;

    return {
        intent: 'cancel',
        paymentGatewayId: paymentGatewayId,
        extraParameters: [
            {
                objectType: 'KalturaKeyValue',
                key: 'subscriptionId',
                value: subscriptionId
            },
            {
                objectType: 'KalturaKeyValue',
                key: 'userId',
                value: userId
            }
        ]
    };
}

/**
 * Converts data for getPaymentHistory.
 *
 * @param {Object} paymentParams - Payment params.
 * @returns {Object} Data for read.
 */
export function convertForGetPaymentHistory (paymentParams) {
    let {defaultGateway, userId} = paymentParams;

    return {
        intent: 'getHistory',
        paymentGatewayId: defaultGateway,
        extraParameters: [
            {
                objectType: 'KalturaKeyValue',
                key: 'userId',
                value: userId
            }
        ]
    };
}

/**
 * Converts data from getPaymentHistory.
 *
 * @param {Object} paymentHistory - Payment history.
 * @returns {Object} Converted data.
 */
export function convertFromGetPaymentHistory (paymentHistory) {

    let {paymentGatewayConfiguration} = paymentHistory,
        paymantHistoryItems = [];


    if (paymentGatewayConfiguration.length) {

        paymantHistoryItems = paymentGatewayConfiguration
            .filter((configurationEntry) => {

                // filter out all other entries which are not history entries
                return _.parseInt(configurationEntry.key) > 0;
            })
            .map((historyEntry) => {

            // kaaltura is sending timestamp is string in format 1506716026.037
                return {
                    timestamp: parseFloat(historyEntry.key) * 1000,
                    invoiceUrl: historyEntry.value || ''
                };
            });
    }

    return paymantHistoryItems;
}




// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/payment.js